export const GROUP_TABLE_HEAD = ["Username", "Email", "Role", ""];
